<div class="card">
    <div class="card-body">
        <h5 class="card-title">{{ 'tasks.cardTitle' | t }}</h5>
        <h6 class="card-subtitle mb-2 text-muted">{{ 'selectExportTypeBelow' | t }}</h6>

        <hr />

        @if (permService.permissions.HasTaskAccess) {
            <button class="btn btn-default me-2 mb-2" (click)="exportTasks()">{{ 'tasks.tasksButton' | t }}</button>
        }
    </div>
</div>
